export type DashboardLanguage = "en" | "am";

const DASHBOARD_LANGUAGE_KEY = "dashboardLanguage";

export const getDashboardLanguage = (): DashboardLanguage =>
  localStorage.getItem(DASHBOARD_LANGUAGE_KEY) === "am" ? "am" : "en";

export const setDashboardLanguage = (language: DashboardLanguage) => {
  localStorage.setItem(DASHBOARD_LANGUAGE_KEY, language);
};

const amharicTranslations: Record<string, string> = {
  Dashboard: "ዳሽቦርድ",
  Cars: "መኪናዎች",
  Users: "ተጠቃሚዎች",
  Messages: "መልእክቶች",
  Reports: "ሪፖርቶች",
  Staff: "ሰራተኞች",
  "Money Request": "የገንዘብ ጥያቄ",
  "Car Request": "የመኪና ጥያቄ",
  "Spare Parts": "መለዋወጫ እቃዎች",
  "Short Videos": "አጫጭር ቪዲዮዎች",
  Notifications: "ማሳወቂያዎች",
  "App Update": "የመተግበሪያ ዝመና",
  "Dealer Market": "የአስመጪዎች ገበያ",
  "Quick Capture": "ፈጣን ምዝገባ",
  "Import Cars": "መኪና አስገባ",
  Valuations: "የመኪና ዋጋ ግምት",
  Distribution: "ማስታወቂያ ስርጭት",
  Management: "አስተዳደር",
  Logout: "ውጣ",
  Login: "ግባ",
  Email: "ኢሜይል",
  Password: "የይለፍ ቃል",
  "Open navigation": "ምናሌውን ክፈት",
  "Close navigation": "ምናሌውን ዝጋ",
  "Go to dashboard": "ወደ ዳሽቦርድ ሂድ",
  "Enter your email address": "ኢሜይልዎን ያስገቡ",
  "Enter your password": "የይለፍ ቃልዎን ያስገቡ",
  "Review today's activity and active listings.":
    "የዛሬን እንቅስቃሴና ንቁ ማስታወቂያዎችን ይመልከቱ።",
  "Today's Statistics": "የዛሬ ስታቲስቲክስ",
  Today: "ዛሬ",
  "All Time": "አጠቃላይ",
  Status: "ሁኔታ",
  Active: "ንቁ",
  Assigned: "የተመደበ",
  Sold: "የተሸጠ",
  Rented: "የተከራየ",
  Cancelled: "የተሰረዘ",
  Deleted: "የተሰረዘ",
  Suspended: "የታገደ",
  Permanent: "ቋሚ",
  Pending: "በመጠባበቅ ላይ",
  Approved: "የጸደቀ",
  Denied: "ውድቅ የተደረገ",
  Rejected: "ውድቅ የተደረገ",
  Published: "የታተመ",
  Hidden: "የተደበቀ",
  Review: "ግምገማ",
  Unavailable: "የማይገኝ",
  Posted: "የተለጠፈ",
  New: "አዲስ",
  Used: "ያገለገለ",
  Rent: "ኪራይ",
  Sale: "ሽያጭ",
  Available: "ይገኛል",
  Unassigned: "አልተመደበም",
  Admin: "አስተዳዳሪ",
  Owner: "ባለቤት",
  Customer: "ደንበኛ",
  Details: "ዝርዝር",
  Date: "ቀን",
  Model: "ሞዴል",
  Price: "ዋጋ",
  Phone: "ስልክ",
  "Phone number": "ስልክ ቁጥር",
  "Phone no.": "ስልክ ቁጥር",
  "Full name": "ሙሉ ስም",
  "Email address": "ኢሜይል",
  Description: "መግለጫ",
  Search: "ፈልግ",
  Clear: "አጽዳ",
  Save: "አስቀምጥ",
  Update: "አዘምን",
  Edit: "አርም",
  Delete: "ሰርዝ",
  Remove: "አስወግድ",
  Cancel: "ይቅር",
  Close: "ዝጋ",
  Confirm: "አረጋግጥ",
  Submit: "አስገባ",
  Register: "መዝግብ",
  Loading: "በመጫን ላይ",
  Retry: "እንደገና ሞክር",
  Back: "ተመለስ",
  Next: "ቀጣይ",
  Previous: "ቀዳሚ",
  "Load more": "ተጨማሪ ጫን",
  "No active listings": "ንቁ ማስታወቂያ የለም",
  "Active listings will appear here when they are posted.":
    "ንቁ ማስታወቂያዎች ሲለጠፉ እዚህ ይታያሉ።",
  "Live Car Status": "የቀጥታ መኪና ሁኔታ",
  "Car no.": "የመኪና ቁጥር",
  "Search live cars...": "የቀጥታ መኪናዎችን ይፈልጉ...",
  "Total Assigned": "የተመደቡ",
  "Total Sold": "የተሸጡ",
  "Total Rent": "የተከራዩ",
  "Total Cancelled": "የተሰረዙ",
  "Total Posts": "ጠቅላላ ማስታወቂያ",
  "Total Sale Posts": "የሽያጭ ማስታወቂያ",
  "Total Rent Posts": "የኪራይ ማስታወቂያ",
  "Total Messages": "ጠቅላላ መልእክቶች",
  "Total Calls": "ጠቅላላ ጥሪዎች",
  "Total Users": "ጠቅላላ ተጠቃሚዎች",
  "User List": "የተጠቃሚዎች ዝርዝር",
  "Staff List": "የሰራተኞች ዝርዝር",
  "User details": "የተጠቃሚ ዝርዝር",
  "Staff details": "የሰራተኛ ዝርዝር",
  "Posted cars": "የለጠፋቸው መኪናዎች",
  Activities: "እንቅስቃሴዎች",
  "Suspend User": "ተጠቃሚውን አግድ",
  "Unsuspend User": "እገዳውን አንሳ",
  "Suspend Staff": "ሰራተኛውን አግድ",
  "Unsuspend Staff": "እገዳውን አንሳ",
  "Register staff": "ሰራተኛ መዝግብ",
  "Update Staff": "ሰራተኛ አዘምን",
  Message: "መልእክት",
  "All Messages": "ሁሉም መልእክቶች",
  "Search messages...": "መልእክት ይፈልጉ...",
  "Type a message...": "መልእክት ይጻፉ...",
  "Send direct message": "ቀጥታ መልእክት ላክ",
  "Send message": "መልእክት ላክ",
  "Open thread": "ውይይቱን ክፈት",
  "Message sent successfully": "መልእክቱ ተልኳል",
  "This opens or creates the conversation for the selected user.":
    "ለተመረጠው ተጠቃሚ ውይይት ይከፍታል ወይም ይፈጥራል።",
  "Reported Posts": "ሪፖርት የተደረጉ ማስታወቂያዎች",
  "Report Status": "የሪፖርት ሁኔታ",
  Reporter: "ሪፖርት ያደረገው",
  Reported: "ሪፖርት የተደረገበት",
  "Call Status": "የጥሪ ሁኔታ",
  "Listing images": "የማስታወቂያ ፎቶዎች",
  "Primary image": "ዋና ፎቶ",
  "Set primary": "ዋና አድርግ",
  images: "ፎቶዎች",
  "Year of Manufacture": "የምርት ዓመት",
  "Mileage, km": "የተጓዘው ኪ.ሜ.",
  "Transmission Type": "የማርሽ ዓይነት",
  "Fuel Type": "የነዳጅ ዓይነት",
  "Usage Type": "የአጠቃቀም ዓይነት",
  "Listing Type": "የማስታወቂያ ዓይነት",
  "Ordered By": "ያዘዘው",
  "Assigned Agent": "የተመደበ ሰራተኛ",
  "Car Owner Phone Number": "የመኪና ባለቤት ስልክ",
  "Posted by": "የለጠፈው",
  "Car owner": "የመኪና ባለቤት",
  "Send an announcement": "ማሳወቂያ ላክ",
  Preview: "ቅድመ እይታ",
  "Loading notifications...": "ማሳወቂያዎች በመጫን ላይ...",
  "Mark all read": "ሁሉንም እንደተነበበ አድርግ",
  "No notifications yet.": "እስካሁን ማሳወቂያ የለም።",
  "Minimum Android build": "ዝቅተኛው የAndroid ቢልድ",
  "Latest Android build": "የቅርብ ጊዜ Android ቢልድ",
  "Play Store URL": "የPlay Store አገናኝ",
  "Update title": "የዝመና ርዕስ",
  "Update message": "የዝመና መልእክት",
  "Admin access is required.": "የአስተዳዳሪ ፈቃድ ያስፈልጋል።",
  "Dealer market": "የአስመጪዎች ገበያ",
  "Importer app account links": "የአስመጪ መተግበሪያ መለያዎች",
  "Choose importer": "አስመጪ ይምረጡ",
  "Link account": "መለያ አገናኝ",
  "No linked app accounts yet.": "እስካሁን የተገናኘ መለያ የለም።",
  "No dealers found.": "አስመጪ አልተገኘም።",
  "No dealer cars found.": "የአስመጪ መኪና አልተገኘም።",
  "No dealer submissions found.": "የአስመጪ ማስገቢያ አልተገኘም።",
  "No ordered-car leads found.": "የታዘዘ መኪና ጥያቄ አልተገኘም።",
  "Car brand": "የመኪና ብራንድ",
  Fuel: "ነዳጅ",
  "Select make": "ብራንድ ይምረጡ",
  "No master profiles found.": "የመኪና ዋና መገለጫ አልተገኘም።",
  Extra: "ተጨማሪ",
  Deal: "ቅናሽ",
  "Contacted dealer": "አስመጪው ተገናኝቷል",
  "Buyer sent": "ገዢ ተልኳል",
  Won: "ተሳክቷል",
  Lost: "አልተሳካም",
  "All statuses": "ሁሉም ሁኔታዎች",
  Category: "ምድብ",
  Qty: "ብዛት",
  "Quote only": "ዋጋ ብቻ",
  "Show price": "ዋጋ አሳይ",
  "Searching cars...": "መኪናዎችን በመፈለግ ላይ...",
  "No short videos yet.": "እስካሁን አጭር ቪዲዮ የለም።",
  "Import an external car listing": "የውጭ መኪና ማስታወቂያ አስገባ",
  "Select the source, review every detail, then publish it to BossCar.":
    "ምንጩን ይምረጡ፣ ዝርዝሩን ያረጋግጡና በBossCar ያትሙ።",
  Extract: "አውጣ",
  Publish: "አትም",
  "Used-car valuations": "የያገለገሉ መኪናዎች ዋጋ ግምት",
  Requests: "ጥያቄዎች",
  "Missing sales": "ያልተመዘገቡ ሽያጮች",
  "Market data": "የገበያ መረጃ",
  "Model review": "የሞዴል ግምገማ",
  "All review states": "ሁሉም የግምገማ ሁኔታዎች",
  "CALIBRATION SCORECARD": "የትክክለኛነት መለኪያ",
  "Verified outcomes": "የተረጋገጡ ውጤቶች",
  "Backtest median error": "የኋላ ሙከራ መካከለኛ ስህተት",
  "Usable model matches": "ጥቅም ላይ የሚውሉ የሞዴል ግጥሚያዎች",
  "Names awaiting review": "ግምገማ የሚጠብቁ ስሞች",
  "Evidence sources": "የማስረጃ ምንጮች",
  "Verified final sales": "የተረጋገጡ የመጨረሻ ሽያጮች",
  "PRICE HISTORY": "የዋጋ ታሪክ",
  "All sources": "ሁሉም ምንጮች",
  "30 days": "30 ቀናት",
  "90 days": "90 ቀናት",
  "6 months": "6 ወራት",
  "1 year": "1 ዓመት",
  "2 years": "2 ዓመታት",
  "Latest advertised median": "የቅርብ ጊዜ የማስታወቂያ መካከለኛ ዋጋ",
  "Change in this period": "በዚህ ጊዜ ያለው ለውጥ",
  "Listings tracked": "የተከታተሉ ማስታወቂያዎች",
  "Independent sources": "ገለልተኛ ምንጮች",
  "Advertised median": "የማስታወቂያ መካከለኛ ዋጋ",
  "Verified sale median": "የተረጋገጠ ሽያጭ መካከለኛ ዋጋ",
  "Collect used-car asking prices": "የያገለገሉ መኪናዎች የጥያቄ ዋጋ ሰብስብ",
  "Review before saving": "ከማስቀመጥዎ በፊት ይገምግሙ",
  "Add a verified market observation": "የተረጋገጠ የገበያ መረጃ ያክሉ",
  "Source type": "የምንጭ ዓይነት",
  "Verified evidence": "የተረጋገጠ ማስረጃ",
  "Loading...": "በመጫን ላይ...",
  "No data": "መረጃ የለም",
  "No valuation requests found.": "የዋጋ ግምት ጥያቄ አልተገኘም።",
  "Likely sale": "ሊሸጥበት የሚችለው ዋጋ",
  "Expected range": "የሚጠበቀው የዋጋ ክልል",
  "Suggested asking": "የሚመከረው የመጠየቂያ ዋጋ",
  Evidence: "ማስረጃ",
  "Save review": "ግምገማ አስቀምጥ",
  "Record completed sale": "የተጠናቀቀ ሽያጭ መዝግብ",
  "Verified by BossCar": "በBossCar የተረጋገጠ",
  "Record sale": "ሽያጭ መዝግብ",
  Vehicle: "መኪና",
  Source: "ምንጭ",
  Asking: "የተጠየቀው ዋጋ",
  "Final sale": "የመጨረሻ ሽያጭ",
  Observed: "የታየበት ቀን",
  "No market observations found.": "የገበያ መረጃ አልተገኘም።",
  "Approve as new": "እንደ አዲስ አጽድቅ",
  Reject: "ውድቅ አድርግ",
  "Select same model": "ተመሳሳይ ሞዴል ይምረጡ",
  "No model names need review.": "ግምገማ የሚፈልግ የሞዴል ስም የለም።",
  "Take photo": "ፎቶ አንሳ",
  "Add photos": "ፎቶዎች ጨምር",
  "Choose listing photos": "የማስታወቂያ ፎቶዎችን ይምረጡ",
  "Save details": "ዝርዝሩን አስቀምጥ",
  "Delete draft": "ረቂቁን ሰርዝ",
  "Publish app, web & Telegram": "በመተግበሪያ፣ ድርና Telegram ላይ አትም",
};

Object.assign(amharicTranslations, {
  "Dashboard navigation": "የዳሽቦርድ ምናሌ",
  "Dashboard sign in": "ወደ ዳሽቦርድ ይግቡ",
  "Use your staff or administrator account.": "የሰራተኛ ወይም የአስተዳዳሪ መለያዎን ይጠቀሙ።",
  "No cars found": "መኪና አልተገኘም",
  "No users found": "ተጠቃሚ አልተገኘም",
  "No staff found": "ሰራተኛ አልተገኘም",
  "No staff activity": "የሰራተኛ እንቅስቃሴ የለም",
  "No reports": "ሪፖርት የለም",
  "No calls": "ጥሪ የለም",
  "No car requests": "የመኪና ጥያቄ የለም",
  "No money requests": "የገንዘብ ጥያቄ የለም",
  "Money requests": "የገንዘብ ጥያቄዎች",
  "Car requests": "የመኪና ጥያቄዎች",
  "Reports and calls": "ሪፖርቶችና ጥሪዎች",
  "Request type": "የጥያቄ ዓይነት",
  Amount: "መጠን",
  "Current balance:": "የአሁኑ ቀሪ ሂሳብ፦",
  "Enter amount": "መጠኑን ያስገቡ",
  "No previous requests.": "የቀድሞ ጥያቄ የለም።",
  Approve: "አጽድቅ",
  Deny: "ውድቅ አድርግ",
  "Actual amount paid": "በትክክል የተከፈለው መጠን",
  "User:": "ተጠቃሚ፦",
  "Phone:": "ስልክ፦",
  "Balance:": "ቀሪ ሂሳብ፦",
  Buyer: "ገዢ",
  Seller: "ሻጭ",
  "Select a conversation": "ውይይት ይምረጡ",
  "Pick a thread from the left to read details and reply.": "ዝርዝሩን ለማንበብና ለመመለስ ከግራ ውይይት ይምረጡ።",
  "Messages could not be loaded": "መልእክቶችን መጫን አልተቻለም",
  "Check the connection and try again.": "የኢንተርኔት ግንኙነቱን አረጋግጠው እንደገና ይሞክሩ።",
  "Try again": "እንደገና ሞክር",
  "No messages yet": "እስካሁን መልእክት የለም",
  "This thread is ready for the first reply.": "ይህ ውይይት የመጀመሪያ ምላሽ ለመቀበል ዝግጁ ነው።",
  "No conversations found": "ውይይት አልተገኘም",
  "Try a different search or wait for a new message to arrive.": "ሌላ ፍለጋ ይሞክሩ ወይም አዲስ መልእክት ይጠብቁ።",
  "Delete Message": "መልእክት ሰርዝ",
  "Failed - Retry": "አልተሳካም - እንደገና ሞክር",
  Seen: "የታየ",
  messages: "መልእክቶች",
  "Car details": "የመኪና ዝርዝር",
  "Edit car listing": "የመኪና ማስታወቂያ አርም",
  "Update the public listing and internal sales details in one place.": "የህዝብ ማስታወቂያውንና የውስጥ ሽያጭ መረጃውን በአንድ ቦታ ያዘምኑ።",
  "Unsaved changes": "ያልተቀመጡ ለውጦች",
  "You have unsaved changes": "ያልተቀመጡ ለውጦች አሉ",
  "All changes are saved": "ሁሉም ለውጦች ተቀምጠዋል",
  "Loading car details...": "የመኪና ዝርዝር በመጫን ላይ...",
  "Return to cars": "ወደ መኪናዎች ተመለስ",
  "Please fix the highlighted listing details before saving.": "ከማስቀመጥዎ በፊት የተመለከቱትን ዝርዝሮች ያስተካክሉ።",
  "LISTING SETUP": "የማስታወቂያ ቅንብር",
  "Type and condition": "ዓይነትና ሁኔታ",
  "Choose how this rental is offered.": "ይህ ኪራይ እንዴት እንደሚቀርብ ይምረጡ።",
  "Driver option": "የአሽከርካሪ ምርጫ",
  "PUBLIC INFORMATION": "የህዝብ መረጃ",
  "These details appear in the app and web listing.": "እነዚህ ዝርዝሮች በመተግበሪያና በድር ማስታወቂያ ላይ ይታያሉ።",
  "Brand *": "ብራንድ *",
  "Select brand": "ብራንድ ይምረጡ",
  "Model *": "ሞዴል *",
  "Year *": "ዓመት *",
  "Price (Birr) *": "ዋጋ (ብር) *",
  "Fuel type *": "የነዳጅ ዓይነት *",
  "Select fuel": "ነዳጅ ይምረጡ",
  Color: "ቀለም",
  "Description *": "መግለጫ *",
  "Describe the condition and important features. Do not add contact details or links.": "ሁኔታውንና ዋና ባህሪያቱን ይግለጹ። የግንኙነት መረጃ ወይም አገናኝ አያክሉ።",
  "More details": "ተጨማሪ ዝርዝሮች",
  "Mileage, transmission, location, phone, and electric range": "የተጓዘው ኪ.ሜ.፣ ማርሽ፣ አካባቢ፣ ስልክና የኤሌክትሪክ ርቀት",
  "Mileage (km)": "የተጓዘው ኪ.ሜ.",
  Optional: "አማራጭ",
  Transmission: "የማርሽ ዓይነት",
  "Not specified": "አልተገለጸም",
  Location: "አካባቢ",
  "Owner phone": "የባለቤት ስልክ",
  "Electric range (km)": "የኤሌክትሪክ ርቀት (ኪ.ሜ.)",
  "LISTING MANAGEMENT": "የማስታወቂያ አስተዳደር",
  "Status and assignment": "ሁኔታና ምደባ",
  "DANGER ZONE": "ከፍተኛ ጥንቃቄ",
  "Delete listing": "ማስታወቂያውን ሰርዝ",
  "This permanently removes the post and uploaded listing photos.": "ይህ ማስታወቂያውንና የተጫኑ ፎቶዎችን ሙሉ በሙሉ ያስወግዳል።",
  "Completed sale": "የተጠናቀቀ ሽያጭ",
  "Record what the buyer actually paid. This improves future price estimates.": "ገዢው በትክክል የከፈለውን ይመዝግቡ። ይህ የወደፊት የዋጋ ግምትን ያሻሽላል።",
  "Final selling price (Birr) *": "የመጨረሻ የሽያጭ ዋጋ (ብር) *",
  "Sold date *": "የተሸጠበት ቀን *",
  "Check only after staff confirms the final price with the buyer or seller.": "ሰራተኛው የመጨረሻውን ዋጋ ከገዢው ወይም ከሻጩ ካረጋገጠ በኋላ ብቻ ምልክት ያድርጉ።",
  "Order details": "የትዕዛዝ ዝርዝር",
  "BUYER FOLLOW-UP": "የገዢ ክትትል",
  "Buyer name": "የገዢ ስም",
  "Buyer phone": "የገዢ ስልክ",
  "Current agent": "የአሁኑ ሰራተኛ",
  "Assigned agent": "የተመደበ ሰራተኛ",
  "POSTED BY": "የለጠፈው",
  "IMPORTED SOURCE": "የገባበት ምንጭ",
  "Open original post": "ዋናውን ማስታወቂያ ክፈት",
  "Discount deal": "የቅናሽ ማስታወቂያ",
  "BossCar inspection": "የBossCar የመኪና ምርመራ",
  "USED CAR TRUST": "የያገለገለ መኪና ታማኝነት",
  "Record what was checked and show every known defect clearly.": "የተመረመረውን ይመዝግቡና የሚታወቁ ጉድለቶችን በግልጽ ያሳዩ።",
  "Loading inspection...": "ምርመራው በመጫን ላይ...",
  "Not inspected": "አልተመረመረም",
  Inspected: "የተመረመረ",
  "Did not pass": "አላለፈም",
  "Last checked": "መጨረሻ የተመረመረበት",
  "Valid until": "የሚያገለግልበት ቀን",
  "Badge removed:": "ምልክቱ ተወግዷል፦",
  "Inspector summary": "የመርማሪ ማጠቃለያ",
  "Inspection checklist": "የምርመራ ዝርዝር",
  "Every item must be checked before the car receives the badge.": "መኪናው ምልክት ከማግኘቱ በፊት እያንዳንዱ ክፍል መመርመር አለበት።",
  checked: "የተመረመሩ",
  "Not checked": "አልተመረመረም",
  Good: "ጥሩ",
  "Needs attention": "ትኩረት ያስፈልገዋል",
  "Optional factual note": "አማራጭ እውነታዊ ማስታወሻ",
  "Known defects": "የሚታወቁ ጉድለቶች",
  "Add a wide photo and a close-up whenever possible.": "ከተቻለ ሙሉ እይታና ቅርብ ፎቶ ያክሉ።",
  "+ Add defect": "+ ጉድለት ጨምር",
  "No defects recorded.": "የተመዘገበ ጉድለት የለም።",
  Defect: "ጉድለት",
  Area: "አካባቢ",
  Severity: "የጉዳት ደረጃ",
  Minor: "ቀላል",
  Moderate: "መካከለኛ",
  Major: "ከባድ",
  "Estimated repair (Birr, optional)": "የጥገና ግምት (ብር፣ አማራጭ)",
  "What did you observe?": "ምን ተመለከቱ?",
  "Describe only what was observed.": "የታየውን ብቻ ይግለጹ።",
  "Remove evidence photo": "የማስረጃ ፎቶ አስወግድ",
  "+ Add photos": "+ ፎቶዎች ጨምር",
  "Add listing photos": "የማስታወቂያ ፎቶዎችን ጨምር",
  "JPG, PNG, or WebP": "JPG፣ PNG ወይም WebP",
  Cover: "ዋና ፎቶ",
  "Move left": "ወደ ግራ አንቀሳቅስ",
  "Move right": "ወደ ቀኝ አንቀሳቅስ",
  "Set cover": "ዋና አድርግ",
  "Main image": "ዋና ፎቶ",
  "No images available": "ፎቶ የለም",
  "Add at least 4 images to keep the listing active.": "ማስታወቂያው ንቁ እንዲሆን ቢያንስ 4 ፎቶዎች ያክሉ።",
  "CONTROLLED SOURCE IMPORT": "ቁጥጥር ያለው የምንጭ ማስገቢያ",
  "shared listing URL": "የተጋራ ማስታወቂያ አገናኝ",
  "Open source": "ምንጩን ክፈት",
  "Source seller:": "የምንጭ ሻጭ፦",
  "Already imported": "ከዚህ በፊት ገብቷል",
  "This source URL is already connected to a BossCar post.": "ይህ የምንጭ አገናኝ ከBossCar ማስታወቂያ ጋር ተገናኝቷል።",
  "Open car": "መኪናውን ክፈት",
  "Review listing details": "የማስታወቂያ ዝርዝሩን ይገምግሙ",
  "Only these reviewed values will appear in BossCar.": "በBossCar ላይ የሚታዩት የተገመገሙት መረጃዎች ብቻ ናቸው።",
  Brand: "ብራንድ",
  Year: "ዓመት",
  "Price (Birr)": "ዋጋ (ብር)",
  Mileage: "የተጓዘው ኪ.ሜ.",
  Listing: "ማስታወቂያ",
  "Source seller (private)": "የምንጭ ሻጭ (የውስጥ)",
  "Source phone (private)": "የምንጭ ስልክ (የውስጥ)",
  Photos: "ፎቶዎች",
  Primary: "ዋና",
  "I confirm BossCar has permission to republish this listing and its photos.": "BossCar ይህን ማስታወቂያና ፎቶዎቹን እንደገና ለማተም ፈቃድ እንዳለው አረጋግጣለሁ።",
  "BOSSCAR OPERATIONS": "የBOSSCAR ስራዎች",
  "Quick car capture": "ፈጣን የመኪና ምዝገባ",
  Capture: "መዝግብ",
  Drafts: "ረቂቆች",
  "1. Dealer": "1. አስመጪ",
  "2. Car & price": "2. መኪናና ዋጋ",
  "3. Photos": "3. ፎቶዎች",
  "Change dealer": "አስመጪ ቀይር",
  "Dealer phone or name": "የአስመጪ ስልክ ወይም ስም",
  "Dealer name (optional)": "የአስመጪ ስም (አማራጭ)",
  "Add this phone": "ይህን ስልክ ጨምር",
  "Extra note": "ተጨማሪ ማስታወሻ",
  "Anything important about this car": "ስለዚህ መኪና አስፈላጊ መረጃ",
  "The draft is still saved if the price is missing.": "ዋጋው ባይሞላም ረቂቁ ይቀመጣል።",
  Gallery: "ፎቶዎች",
  "Take next photo": "ቀጣዩን ፎቶ አንሳ",
  "Remove photo": "ፎቶ አስወግድ",
  "Remove failed uploads": "ያልተሳኩ ፎቶዎችን አስወግድ",
  "Save & next car": "አስቀምጥና ወደ ቀጣዩ መኪና",
  "Captured cars": "የተመዘገቡ መኪናዎች",
  "Newest activity first. All staff can finish these drafts.": "አዲሱ እንቅስቃሴ ቀድሞ ይታያል። ማንኛውም ሰራተኛ ረቂቆቹን ማጠናቀቅ ይችላል።",
  Needs: "የሚያስፈልገው",
  "Complete car details": "የመኪና ዝርዝር ይሙሉ",
  "Extra note / description": "ተጨማሪ ማስታወሻ / መግለጫ",
  "Select color": "ቀለም ይምረጡ",
  "Select transmission": "ማርሽ ይምረጡ",
  Usage: "አጠቃቀም",
  Automatic: "አውቶማቲክ",
  Manual: "ማንዋል",
  "Semi-Automatic": "ሴሚ አውቶማቲክ",
  Electric: "ኤሌክትሪክ",
  Gas: "ቤንዚን",
  Diesel: "ዲዝል",
  Hybrid: "ሃይብሪድ",
  "Use in listing": "በማስታወቂያ ተጠቀም",
  "Move earlier": "ወደ ፊት አንቀሳቅስ",
  "Move later": "ወደ ኋላ አንቀሳቅስ",
  Crop: "ቁረጥ",
  "Crop photo": "ፎቶውን ቁረጥ",
  Zoom: "አጉላ",
  "Left / right": "ግራ / ቀኝ",
  "Up / down": "ላይ / ታች",
  "Apply crop": "መቁረጡን ተግብር",
  "Delete draft": "ረቂቁን ሰርዝ",
  "Retry upload": "መጫኑን እንደገና ሞክር",
  "Retry photo upload": "ፎቶ መጫኑን እንደገና ሞክር",
  "Short Videos": "አጫጭር ቪዲዮዎች",
  "Upload staff-curated BossCar short videos for the app Videos tab.": "በመተግበሪያው የቪዲዮ ገጽ ላይ የሚታዩ የBossCar አጫጭር ቪዲዮዎችን ይጫኑ።",
  Title: "ርዕስ",
  "Example: New arrivals at BossCar": "ምሳሌ፦ በBossCar አዲስ የገቡ",
  "Short caption shown on the video feed": "በቪዲዮ ገጹ ላይ የሚታይ አጭር መግለጫ",
  "Video file": "የቪዲዮ ፋይል",
  "Optional linked car": "አማራጭ የተገናኘ መኪና",
  "Search tag, make, model, year": "መለያ፣ ብራንድ፣ ሞዴል ወይም ዓመት ይፈልጉ",
  "Clear linked car:": "የተገናኘውን መኪና አስወግድ፦",
  "Linked car:": "የተገናኘ መኪና፦",
  "Search title, description, status": "ርዕስ፣ መግለጫ ወይም ሁኔታ ይፈልጉ",
  "Spare Parts": "መለዋወጫ እቃዎች",
  "Manage EV/body-part requests and simple BossCar catalog items.": "የኤሌክትሪክና የቦዲ መለዋወጫ ጥያቄዎችን እና የBossCar እቃዎችን ያስተዳድሩ።",
  "Search phone, part, make, model, city": "ስልክ፣ እቃ፣ ብራንድ፣ ሞዴል ወይም ከተማ ይፈልጉ",
  "Part title": "የእቃ ስም",
  Catalog: "ካታሎግ",
  "Search catalog products": "የካታሎግ እቃዎችን ይፈልጉ",
  "Quoted price": "የተጠቀሰው ዋጋ",
  "Staff notes": "የሰራተኛ ማስታወሻ",
  "Force old Android builds to update from Google Play.": "የድሮ Android ቢልዶች ከGoogle Play እንዲዘምኑ ያስገድዱ።",
  "Builds below this number are blocked.": "ከዚህ ቁጥር በታች ያሉ ቢልዶች ይታገዳሉ።",
  "Informational value for the newest release.": "ስለ አዲሱ ልቀት የሚያሳይ መረጃ።",
  "If the app cannot reach the server, users are allowed in so they are not locked out by a temporary network issue.": "መተግበሪያው ሰርቨሩን ማግኘት ካልቻለ በጊዜያዊ የኢንተርኔት ችግር ተጠቃሚዎች አይታገዱም።",
  "Use system alerts only for important service or account information.": "የስርዓት ማሳወቂያን ለአስፈላጊ አገልግሎት ወይም መለያ መረጃ ብቻ ይጠቀሙ።",
  "Important update": "አስፈላጊ ዝመና",
  "Offer / promotion": "ቅናሽ / ማስተዋወቂያ",
  "Clear, short title": "አጭርና ግልጽ ርዕስ",
  "Tell users what happened and what they should do": "የተፈጠረውንና ተጠቃሚዎች ምን ማድረግ እንዳለባቸው ይጻፉ",
  "Amharic title": "የአማርኛ ርዕስ",
  "Amharic message": "የአማርኛ መልእክት",
  "Search notifications": "ማሳወቂያ ይፈልጉ",
  "Notifications could not be loaded.": "ማሳወቂያዎችን መጫን አልተቻለም።",
  "Manage importer/dealer price-list rows, hidden buyer leads, and trusted dealer publishing.": "የአስመጪዎችን የዋጋ ዝርዝር፣ የገዢ ጥያቄዎችና የታመኑ አስመጪዎችን ያስተዳድሩ።",
  Refresh: "አድስ",
  "Search dealer cars": "የአስመጪ መኪናዎችን ይፈልጉ",
  "Search by voice": "በድምጽ ይፈልጉ",
  "Voice search": "የድምጽ ፍለጋ",
  "Dealer name": "የአስመጪ ስም",
  Notes: "ማስታወሻ",
  "Trusted dealer": "የታመነ አስመጪ",
  "Can post new cars": "አዲስ መኪና መለጠፍ ይችላል",
  "Cancel edit": "ማስተካከያውን ይቅር",
  "App user phone": "የመተግበሪያ ተጠቃሚ ስልክ",
  "Link a normal BossCar app user phone to an importer/dealer account.": "መደበኛ የBossCar ተጠቃሚ ስልክን ከአስመጪ መለያ ጋር ያገናኙ።",
  "Staff note for dealer": "ለአስመጪው የሰራተኛ ማስታወሻ",
  "Flag suspicious": "አጠራጣሪ ብለው ምልክት ያድርጉ",
  "Commission / notes": "ኮሚሽን / ማስታወሻ",
  "Description / note": "መግለጫ / ማስታወሻ",
  "Model name": "የሞዴል ስም",
  "Save model": "ሞዴሉን አስቀምጥ",
  "Publish app, web & prices": "በመተግበሪያ፣ ድርና ዋጋ ገጽ ላይ አትም",
  "Show in Deals portal": "በቅናሽ ገጽ ላይ አሳይ",
  "This car will appear in Deals for 48 hours after publish, then remain as a normal marketplace post.": "መኪናው ከታተመ በኋላ ለ48 ሰዓት በቅናሽ ገጽ ላይ ይታያል፤ ከዚያ እንደ መደበኛ ማስታወቂያ ይቆያል።",
  "Used-car valuations": "የያገለገሉ መኪናዎች ዋጋ ግምት",
  "BOSSCAR MARKET INTELLIGENCE": "የBOSSCAR የገበያ መረጃ",
  "Review selling-price estimates and capture the final prices that improve future results.": "የሽያጭ ዋጋ ግምቶችን ይገምግሙና የወደፊት ውጤቶችን የሚያሻሽሉ የመጨረሻ ዋጋዎችን ይመዝግቡ።",
  "Cold-start mode:": "የመጀመሪያ መረጃ ሁኔታ፦",
  "imported listings are advertised prices, not completed sales. Review every provisional estimate and record real final selling prices to improve the system.": "የገቡ ማስታወቂያዎች የተጠየቁ ዋጋዎች እንጂ የተጠናቀቁ ሽያጮች አይደሉም። ስርዓቱን ለማሻሻል እያንዳንዱን ጊዜያዊ ግምት ይገምግሙና ትክክለኛውን የሽያጭ ዋጋ ይመዝግቡ።",
  "Backtest within 10%": "በ10% ውስጥ ያለ የኋላ ሙከራ",
  "Backtest within 15%": "በ15% ውስጥ ያለ የኋላ ሙከራ",
  "Only accepted identities can become comparables.": "የጸደቁ የመኪና መለያዎች ብቻ ለንጽጽር ይጠቅማሉ።",
  "Resolve spelling and naming differences in Model review.": "የፊደልና የስያሜ ልዩነቶችን በሞዴል ግምገማ ያስተካክሉ።",
  "Diverse independent sources reduce bias.": "የተለያዩ ገለልተኛ ምንጮች አድልዎን ይቀንሳሉ።",
  "These are the strongest price observations.": "እነዚህ በጣም ጠንካራ የዋጋ ማስረጃዎች ናቸው።",
  "Red is the median advertised price. Green is the median final sale price verified by BossCar.": "ቀይ የማስታወቂያ መካከለኛ ዋጋ ነው። አረንጓዴ በBossCar የተረጋገጠ የመጨረሻ ሽያጭ መካከለኛ ዋጋ ነው።",
  "Use the search box above, for example": "ከላይ ያለውን የፍለጋ ሳጥን ይጠቀሙ፣ ለምሳሌ",
  ". Combining unrelated models would create a misleading graph.": ". የማይዛመዱ ሞዴሎችን ማጣመር የተሳሳተ ግራፍ ይፈጥራል።",
  "Loading price history...": "የዋጋ ታሪክ በመጫን ላይ...",
  "No dated prices match this vehicle and period yet. Add evidence below; the graph will grow from each observation date.": "ለዚህ መኪናና ጊዜ የሚዛመድ ቀን ያለው ዋጋ ገና የለም። ከታች ማስረጃ ያክሉ፤ ግራፉ ከእያንዳንዱ ቀን ጋር ያድጋል።",
  "JIJI PRICE EVIDENCE": "የJIJI የዋጋ ማስረጃ",
  "Paste individual car links, one per line. BossCar stores only vehicle facts, asking price, observation date, and price history for internal valuation. It does not create posts or retain photos, descriptions, or seller details.": "የእያንዳንዱን መኪና አገናኝ በየመስመሩ ያስገቡ። BossCar ለውስጥ ዋጋ ግምት የመኪና መረጃ፣ የተጠየቀ ዋጋ፣ ቀንና የዋጋ ታሪክ ብቻ ያስቀምጣል።",
  "Up to 25 individual listing links per batch. Search and category pages are rejected.": "በአንድ ጊዜ እስከ 25 የግል ማስታወቂያ አገናኞች። የፍለጋና የምድብ ገጾች አይቀበሉም።",
  "Review and correct one link before saving": "ከማስቀመጥዎ በፊት አንዱን አገናኝ ይገምግሙና ያስተካክሉ",
  "Confirm this public URL may be used as internal price evidence": "ይህ የህዝብ አገናኝ እንደ የውስጥ የዋጋ ማስረጃ መጠቀም እንደሚቻል ያረጋግጡ",
  "Final selling prices are the strongest evidence. Asking prices are kept separate.": "የመጨረሻ የሽያጭ ዋጋዎች በጣም ጠንካራ ማስረጃዎች ናቸው። የተጠየቁ ዋጋዎች ተለይተው ይቀመጣሉ።",
  "Import an authorized market dataset": "ፈቃድ ያለው የገበያ መረጃ አስገባ",
  "Use licensed/API/partner data only. Records improve private valuation evidence and are not published as BossCar listings.": "ፈቃድ ያለውን፣ API ወይም የአጋር መረጃ ብቻ ይጠቀሙ። መረጃው የውስጥ ዋጋ ግምትን ያሻሽላል እንጂ እንደ BossCar ማስታወቂያ አይታተምም።",
  "BossCar has permission to use this source data for valuation": "BossCar ይህን የምንጭ መረጃ ለዋጋ ግምት ለመጠቀም ፈቃድ አለው",
  "Actual selling price": "ትክክለኛው የሽያጭ ዋጋ",
  "Original asking price": "የመጀመሪያው የተጠየቀ ዋጋ",
  "Review notes": "የግምገማ ማስታወሻ",
  "Staff low": "የሰራተኛ ዝቅተኛ ግምት",
  "Staff likely": "የሰራተኛ የሚጠበቅ ግምት",
  "Staff high": "የሰራተኛ ከፍተኛ ግምት",
  "Recover the final price for every completed listing.": "ለእያንዳንዱ የተጠናቀቀ ማስታወቂያ የመጨረሻውን ዋጋ ያግኙ።",
  "A sold label alone cannot train or test the estimator. Call the owner, verify the agreed price, then record it on the car page.": "‘ተሽጧል’ የሚል ምልክት ብቻ የዋጋ ግምት ስርዓቱን ለማሰልጠን አይበቃም። ባለቤቱን ደውለው የተስማሙበትን ዋጋ ያረጋግጡና በመኪናው ገጽ ይመዝግቡ።",
  "No sold listings are missing a final price.": "የመጨረሻ ዋጋ ያልተመዘገበለት የተሸጠ ማስታወቂያ የለም።",
  "Review uncertain names before they affect valuations.": "ግልጽ ያልሆኑ ስሞች በዋጋ ግምት ላይ ተጽእኖ ከማሳደራቸው በፊት ይገምግሙ።",
  "Approve a genuinely new model, merge a misspelling or reordered name into an approved model, or reject unusable data.": "በእውነት አዲስ ሞዴልን ያጽድቁ፣ የፊደል ስህተትን ከጸደቀ ሞዴል ጋር ያዋህዱ ወይም የማይጠቅም መረጃን ውድቅ ያድርጉ።",
  "No automated evidence match for this choice. Confirm the exact model manually before merging.": "ለዚህ ምርጫ ራሱን የቻለ የማስረጃ ግጥሚያ የለም። ከማዋሃድዎ በፊት ትክክለኛውን ሞዴል በእጅ ያረጋግጡ።",
  "Vehicle price trend over time": "የመኪና ዋጋ ለውጥ በጊዜ",
  "No price": "ዋጋ የለም",
  "Redirecting to the public share page": "ወደ ህዝባዊ የማጋራት ገጽ በመሄድ ላይ",
  "This link now opens from the public BossCar share system instead of the dashboard.": "ይህ አገናኝ ከዳሽቦርድ ይልቅ በBossCar ህዝባዊ የማጋራት ስርዓት ይከፈታል።",
  Continue: "ቀጥል",
  "“Inspected” reports are public for 14 days. Major defects cannot pass.": "‘የተመረመረ’ ሪፖርት ለ14 ቀናት ለህዝብ ይታያል። ከባድ ጉድለት ያለበት መኪና ምርመራውን አያልፍም።",
  "(optional)": "(አማራጭ)",
  "/ observed today": "/ ዛሬ የታየ",
  "/ Owner:": "/ ባለቤት፦",
  "/10 selected · minimum 3 · first selected photo is primary": "/10 ተመርጠዋል · ቢያንስ 3 · የመጀመሪያው ፎቶ ዋና ነው",
  "&middot;": "·",
  "| Buyer:": "| ገዢ፦",
  "| Dealer phone:": "| የአስመጪ ስልክ፦",
  "| Importer:": "| አስመጪ፦",
  "| Phone:": "| ስልክ፦",
  "| score": "| ነጥብ",
  "Active link": "ንቁ አገናኝ",
  "Add staff": "ሰራተኛ ጨምር",
  "advertised /": "የታወጀ /",
  "App:": "መተግበሪያ፦",
  AutoEstimated: "በስርዓት የተገመተ",
  "before it can be used in an estimate.": "በዋጋ ግምት ላይ ከመጠቀሙ በፊት።",
  Birr: "ብር",
  Br: "ብር",
  "BossCar Share": "የBossCar ማጋራት",
  BossCarListing: "የBossCar ማስታወቂያ",
  "Clear search": "ፍለጋውን አጽዳ",
  "Close camera": "ካሜራውን ዝጋ",
  Closed: "የተዘጋ",
  "compatible /": "ተስማሚ /",
  "completed /": "የተጠናቀቀ /",
  CompletedSale: "የተጠናቀቀ ሽያጭ",
  "confidence / quality": "እምነት / ጥራት",
  contact: "ግንኙነት",
  "Dealer:": "አስመጪ፦",
  DealerQuote: "የአስመጪ ዋጋ",
  "Delete failed photo": "ያልተሳካውን ፎቶ ሰርዝ",
  "Detail match:": "የዝርዝር ግጥሚያ፦",
  Done: "ጨርስ",
  "exact /": "ትክክለኛ /",
  "Example: Clean daily-use car. Two minor body defects are disclosed below.": "ምሳሌ፦ ንጹህ የዕለት መኪና። ሁለት ቀላል የቦዲ ጉድለቶች ከታች ተገልጸዋል።",
  "Example: Rear bumper": "ምሳሌ፦ የኋላ ባምፐር",
  Expires: "የሚያበቃበት",
  ExternalListing: "የውጭ ማስታወቂያ",
  "Flags:": "ምልክቶች፦",
  "JPG, PNG, WEBP, HEIC or AVIF. Up to": "JPG፣ PNG፣ WEBP፣ HEIC ወይም AVIF። እስከ",
  "km ·": "ኪ.ሜ. ·",
  "KM range per charge": "በአንድ ቻርጅ የሚጓዘው ኪ.ሜ.",
  "Latest build:": "የቅርብ ጊዜ ቢልድ፦",
  "leakage-free tests": "መረጃ የማይደባለቅ ሙከራ",
  "LISTING PHOTOS": "የማስታወቂያ ፎቶዎች",
  listings: "ማስታወቂያዎች",
  "MP4 or MOV only. Maximum 50MB. Recommended under 60 seconds.": "MP4 ወይም MOV ብቻ። ከፍተኛው 50MB። ከ60 ሰከንድ በታች ይመከራል።",
  "need follow-up": "ክትትል ያስፈልጋቸዋል",
  NeedsReview: "ግምገማ ያስፈልገዋል",
  "No car brands loaded yet. Refresh after the API is available.": "እስካሁን የመኪና ብራንድ አልተጫነም። APIው ሲሰራ ያድሱ።",
  "No dealer submissions match this status.": "ከዚህ ሁኔታ ጋር የሚዛመድ የአስመጪ ማስገቢያ የለም።",
  "No phone": "ስልክ የለም",
  "Original asking:": "የመጀመሪያ የተጠየቀው፦",
  "Override:": "ተለዋጭ ዋጋ፦",
  photos: "ፎቶዎች",
  "photos.": "ፎቶዎች።",
  "Public:": "ለህዝብ፦",
  "queued photo(s)": "በተራ የሚጠብቁ ፎቶዎች",
  "Record final price": "የመጨረሻ ዋጋ መዝግብ",
  rejected: "ውድቅ የተደረጉ",
  Retake: "እንደገና አንሳ",
  "Retry Telegram": "Telegramን እንደገና ሞክር",
  "Review reasons:": "የግምገማ ምክንያቶች፦",
  Reviewed: "የተገመገመ",
  "Search make, model or phone": "ብራንድ፣ ሞዴል ወይም ስልክ ይፈልጉ",
  "selected / at least 1 required / maximum 10": "ተመርጠዋል / ቢያንስ 1 ያስፈልጋል / ከፍተኛው 10",
  "Sold listing": "የተሸጠ ማስታወቂያ",
  "Source provider, for example Mekina or Gari": "የምንጭ አቅራቢ፣ ለምሳሌ Mekina ወይም Gari",
  "Telegram:": "Telegram፦",
  "The conversation is ready. Open the thread to continue the chat.": "ውይይቱ ዝግጁ ነው። ለመቀጠል ውይይቱን ይክፈቱ።",
  "The first photo is the cover. Keep": "የመጀመሪያው ፎቶ ዋና ፎቶ ነው። ያስቀምጡ",
  uploaded: "ተጭኗል",
  "Use phone camera": "የስልክ ካሜራ ተጠቀም",
  verified: "የተረጋገጠ",
  videos: "ቪዲዮዎች",
  "Fetching Cars Failed": "መኪናዎችን መጫን አልተሳካም",
  "Fetching Live Cars Failed": "የቀጥታ መኪናዎችን መጫን አልተሳካም",
  "Fetching Car Failed": "መኪናውን መጫን አልተሳካም",
  "Fetching Car by Tag Failed": "መኪናውን በመለያ መፈለግ አልተሳካም",
  "Car Updated Successfully": "መኪናው ተዘምኗል",
  "Updating Car Failed": "መኪናውን ማዘመን አልተሳካም",
  "Fetching User Cars Failed": "የተጠቃሚውን መኪናዎች መጫን አልተሳካም",
  "Car reposted successfully": "መኪናው እንደገና ተለጥፏል",
  "Reposting Car Failed": "መኪናውን እንደገና መለጠፍ አልተሳካም",
  "Car deleted successfully": "መኪናው ተሰርዟል",
  "Deleting Car Failed": "መኪናውን መሰረዝ አልተሳካም",
  "Fetching Car Requests Failed": "የመኪና ጥያቄዎችን መጫን አልተሳካም",
  "Fetching Conversation Failed": "ውይይቱን መጫን አልተሳካም",
  "Fetching Conversations Failed": "ውይይቶችን መጫን አልተሳካም",
  "Fetching Messages Failed": "መልእክቶችን መጫን አልተሳካም",
  "Sending Message Failed": "መልእክት መላክ አልተሳካም",
  "Updating Messages Failed": "መልእክቶችን ማዘመን አልተሳካም",
  "Deleting Message Failed": "መልእክቱን መሰረዝ አልተሳካም",
  "Login Successful": "በተሳካ ሁኔታ ገብተዋል",
  "Staff Registered Successfully": "ሰራተኛው ተመዝግቧል",
  "Staff Registration Failed": "ሰራተኛውን መመዝገብ አልተሳካም",
  "Fetching Agents Failed": "ሰራተኞችን መጫን አልተሳካም",
  "Fetching Staff Failed": "ሰራተኞችን መጫን አልተሳካም",
  "Fetching Staff Details Failed": "የሰራተኛ ዝርዝር መጫን አልተሳካም",
  "Fetching Users Failed": "ተጠቃሚዎችን መጫን አልተሳካም",
  "Fetching User Failed": "ተጠቃሚውን መጫን አልተሳካም",
  "User Updated Successfully": "ተጠቃሚው ተዘምኗል",
  "Updating User Failed": "ተጠቃሚውን ማዘመን አልተሳካም",
  "User Type Updated Successfully": "የተጠቃሚው ዓይነት ተዘምኗል",
  "Updating User Type Failed": "የተጠቃሚውን ዓይነት ማዘመን አልተሳካም",
  "Staff Suspension Updated": "የሰራተኛው እገዳ ተዘምኗል",
  "Staff Suspension Failed": "የሰራተኛውን እገዳ ማዘመን አልተሳካም",
  "User Suspension Updated": "የተጠቃሚው እገዳ ተዘምኗል",
  "User Suspension Failed": "የተጠቃሚውን እገዳ ማዘመን አልተሳካም",
  "User Suspended": "ተጠቃሚው ታግዷል",
  "Suspending User Failed": "ተጠቃሚውን ማገድ አልተሳካም",
  "User Unsuspended": "የተጠቃሚው እገዳ ተነስቷል",
  "Unsuspending User Failed": "የተጠቃሚውን እገዳ ማንሳት አልተሳካም",
  "Fetching Reports Failed": "ሪፖርቶችን መጫን አልተሳካም",
  "Fetching Clicks Failed": "ጥሪዎችን መጫን አልተሳካም",
  "Fetching Money Requests Failed": "የገንዘብ ጥያቄዎችን መጫን አልተሳካም",
  "Fetching User Money Requests Failed": "የተጠቃሚውን የገንዘብ ጥያቄዎች መጫን አልተሳካም",
  "Money Request Updated Successfully": "የገንዘብ ጥያቄው ተዘምኗል",
  "Updating Money Request Failed": "የገንዘብ ጥያቄውን ማዘመን አልተሳካም",
  "Fetching Total Statistics Failed": "አጠቃላይ ስታቲስቲክስን መጫን አልተሳካም",
  "Fetching Today Statistics Failed": "የዛሬን ስታቲስቲክስ መጫን አልተሳካም",
  "Car changes saved": "የመኪናው ለውጦች ተቀምጠዋል",
  "Car moved to the top": "መኪናው ወደ ላይ ተወስዷል",
  "Car could not be reposted.": "መኪናውን እንደገና መለጠፍ አልተቻለም።",
  "Car deleted": "መኪናው ተሰርዟል",
  "Car could not be deleted.": "መኪናውን መሰረዝ አልተቻለም።",
  "Discard unsaved changes?": "ያልተቀመጡ ለውጦችን ይተዉ?",
  "Permanently delete this listing and its photos?": "ይህን ማስታወቂያና ፎቶዎቹን ሙሉ በሙሉ ይሰርዙ?",
  "Remove the BossCar inspection and all defect evidence?": "የBossCar ምርመራውንና ሁሉንም የጉድለት ማስረጃዎች ያስወግዱ?",
  "Remove this app account from the importer account?": "ይህን የመተግበሪያ መለያ ከአስመጪው መለያ ያስወግዱ?",
  "Please select the duration of suspension": "እባክዎ የእገዳውን ጊዜ ይምረጡ",
  "model is required": "ሞዴል ያስፈልጋል",
  "Year of manufacturing is requred": "የምርት ዓመት ያስፈልጋል",
  "Year of manufacturing must be 4 characters": "የምርት ዓመት 4 አሃዝ መሆን አለበት",
  "Make is required": "ብራንድ ያስፈልጋል",
  "Price is required": "ዋጋ ያስፈልጋል",
  "Mileage is required": "የተጓዘው ኪ.ሜ. ያስፈልጋል",
  "Transmission type is required": "የማርሽ ዓይነት ያስፈልጋል",
  "Fuel type is required": "የነዳጅ ዓይነት ያስፈልጋል",
  "Listing type is required": "የማስታወቂያ ዓይነት ያስፈልጋል",
  "Usage type is required": "የአጠቃቀም ዓይነት ያስፈልጋል",
  "Owner Phone is required": "የባለቤት ስልክ ያስፈልጋል",
  "Owner phone must include at least 6 digits": "የባለቤት ስልክ ቢያንስ 6 አሃዝ ሊኖረው ይገባል",
  "Desciption is required": "መግለጫ ያስፈልጋል",
  "Description cannot include phone number, email, or Telegram address.": "መግለጫው ስልክ ቁጥር፣ ኢሜይል ወይም የTelegram አድራሻ ሊይዝ አይችልም።",
  "Buyer Phone Number must be 10 digits": "የገዢው ስልክ ቁጥር 10 አሃዝ መሆን አለበት",
  "-day half-life /": "-ቀን የግማሽ ሕይወት /",
  "/ unlimited draft photos": "/ ያልተገደቡ የረቂቅ ፎቶዎች",
  "Accepted car": "የተቀበለ መኪና",
  "Addis Ababa": "አዲስ አበባ",
  "ClicksPage": "የጥሪዎች ገጽ",
  "Crop preview": "የመቁረጫ ቅድመ እይታ",
  "e.g. 420": "ለምሳሌ፦ 420",
  "e.g. Corolla Cross": "ለምሳሌ፦ Corolla Cross",
  "e.g. Pearl white": "ለምሳሌ፦ ዕንቁ ነጭ",
  "Payment proof": "የክፍያ ማስረጃ",
  "Payment screenshot": "የክፍያ ስክሪንሾት",
  "PrimaryInput": "ዋና የግቤት መስክ",
  "Requested spare part": "የተጠየቀ መለዋወጫ",
  "Review captured car": "የተመዘገበውን መኪና ይገምግሙ",
  ": advertised median": "፦ የማስታወቂያ መካከለኛ ዋጋ",
  ": verified sale median": "፦ የተረጋገጠ ሽያጭ መካከለኛ ዋጋ",
  "(optional replacement)": "(አማራጭ ምትክ)",
  "/ Closest:": "/ በጣም ቅርብ፦",
  "/ median": "/ መካከለኛ ዋጋ",
  "/ No safe suggestion": "/ አስተማማኝ ምክር የለም",
  "/ Verified": "/ የተረጋገጠ",
  "+ Add Amharic version": "+ የአማርኛ ቅጂ ጨምር",
  "1 day": "1 ቀን",
  "3 days": "3 ቀናት",
  "1 month": "1 ወር",
  "Activate link": "አገናኙን አግብር",
  "Add product": "ምርት ጨምር",
  "Advertised price": "የማስታወቂያ ዋጋ",
  "Allow posting": "መለጠፍ ፍቀድ",
  "Announcement title": "የማስታወቂያ ርዕስ",
  "App user": "የመተግበሪያ ተጠቃሚ",
  "At least": "ቢያንስ",
  "Audience: every active BossCar account": "ተቀባዮች፦ ሁሉም ንቁ የBossCar መለያዎች",
  "Audience: users who enabled offers and promotions": "ተቀባዮች፦ ቅናሽና ማስተዋወቂያ የፈቀዱ ተጠቃሚዎች",
  "Car was not found.": "መኪናው አልተገኘም።",
  "Close composer": "መልእክት መጻፊያውን ዝጋ",
  "Collect prices": "ዋጋዎችን ሰብስብ",
  "Complete details": "ዝርዝሩን አሟላ",
  "Confirm same model": "ተመሳሳይ ሞዴል መሆኑን አረጋግጥ",
  "Create dealer": "አስመጪ ፍጠር",
  "Current brand": "የአሁኑ ብራንድ",
  "Customer call activity will appear here.": "የደንበኛ ጥሪ እንቅስቃሴ እዚህ ይታያል።",
  "Deactivate link": "አገናኙን አቦዝን",
  "Dealer submitted car": "በአስመጪ የቀረበ መኪና",
  "Duplicate link skipped": "የተደገመ አገናኝ ታልፏል",
  "Each model needs 30 historical tests, median error at most 10%, and 80% within 15%; the global scorecard must also pass": "እያንዳንዱ ሞዴል 30 ታሪካዊ ሙከራዎች፣ ከ10% ያልበለጠ መካከለኛ ስህተት እና 80% ውጤት በ15% ውስጥ ያስፈልገዋል፤ አጠቃላይ የውጤት ሰሌዳውም ማለፍ አለበት",
  "Edit video": "ቪዲዮ አርትዕ",
  "Extracting the Gari listing and photos...": "የGari ማስታወቂያና ፎቶዎች እየወጡ ነው...",
  "Extraction failed": "መረጃውን ማውጣት አልተሳካም",
  "Fuel unknown": "ነዳጅ አልተገለጸም",
  "Guest request": "የእንግዳ ጥያቄ",
  "Hide details": "ዝርዝሩን ደብቅ",
  "Image URL": "የፎቶ አገናኝ",
  "Import dataset": "የመረጃ ስብስቡን አስገባ",
  "Listing updates by this staff member will appear here.": "በዚህ ሰራተኛ የተደረጉ የማስታወቂያ ለውጦች እዚህ ይታያሉ።",
  "Loading more users...": "ተጨማሪ ተጠቃሚዎች እየተጫኑ ነው...",
  "Manual judgment required.": "የሰራተኛ ውሳኔ ያስፈልጋል።",
  "Marked sold": "እንደተሸጠ ተመዝግቧል",
  "Merge as alias": "እንደ ተለዋጭ ስም አዋህድ",
  "Mileage unknown": "ርቀት አልተገለጸም",
  "model(s) passed both model-level and global accuracy gates": "ሞዴል(ሎች) የሞዴልና የአጠቃላይ ትክክለኛነት መስፈርትን አልፈዋል",
  "Move listing to top": "ማስታወቂያውን ወደ ላይ አውጣ",
  "New balance requests will appear here.": "አዲስ የሂሳብ መሙያ ጥያቄዎች እዚህ ይታያሉ።",
  "New buyer requests will appear here.": "አዲስ የገዢ ጥያቄዎች እዚህ ይታያሉ።",
  "New car": "አዲስ መኪና",
  "New password optional": "አዲስ የይለፍ ቃል (አማራጭ)",
  "New/Used comes from Mekina's RSS category. Always confirm it before publishing.": "አዲስ/ያገለገለ የሚለው ከMekina RSS ምድብ ይመጣል። ከማተምዎ በፊት ሁልጊዜ ያረጋግጡ።",
  "No description": "መግለጫ የለም",
  "No driver": "ያለ ሹፌር",
  "No email": "ኢሜይል የለም",
  "No notifications found.": "ማሳወቂያ አልተገኘም።",
  "No unread notifications.": "ያልተነበበ ማሳወቂያ የለም።",
  "Normal marketplace listing": "መደበኛ የገበያ ማስታወቂያ",
  "Not entered": "አልተገባም",
  "Not provided": "አልተሰጠም",
  "Not set": "አልተዘጋጀም",
  "Paste only the Gari URL. The authorized BossCar connector extracts the listing details and original photos for review.": "የGari አገናኙን ብቻ ይለጥፉ። የተፈቀደለት የBossCar አገናኝ ዝርዝሩንና ዋና ፎቶዎቹን ለግምገማ ያወጣል።",
  "Pause posting": "መለጠፍን አቁም",
  "Phone unavailable": "ስልክ አይገኝም",
  "photos are required": "ፎቶዎች ያስፈልጋሉ",
  "Preparing the review...": "ግምገማው እየተዘጋጀ ነው...",
  "Price missing": "ዋጋ የለም",
  "Price on request": "ዋጋ በጥያቄ",
  "price over time": "የዋጋ ለውጥ በጊዜ",
  "provisional calibration": "ጊዜያዊ ማስተካከያ",
  "Publish to BossCar": "በBossCar ላይ አትም",
  "Publish video": "ቪዲዮ አትም",
  "Read price": "ዋጋውን አንብብ",
  "Remove Amharic version": "የአማርኛ ቅጂውን አስወግድ",
  "Review and send": "ገምግመው ይላኩ",
  "sale(s)": "ሽያጭ(ዎች)",
  "Save changes": "ለውጦችን አስቀምጥ",
  "Save inspection": "ምርመራውን አስቀምጥ",
  "Save Jiji price": "የJiji ዋጋ አስቀምጥ",
  "Save observation": "የታየውን መረጃ አስቀምጥ",
  "Save policy": "የዝመና መመሪያውን አስቀምጥ",
  "Search a vehicle to see its price trend": "የዋጋ ለውጡን ለማየት መኪና ይፈልጉ",
  "Send announcement": "ማሳወቂያ ላክ",
  "Sold date missing": "የተሸጠበት ቀን የለም",
  "Source car": "የምንጭ መኪና",
  "Source seller": "የምንጭ ሻጭ",
  "Strong spelling/order match. Confirm only if these are the same model.": "የፊደልና የቅደም ተከተል ጠንካራ መመሳሰል አለ። ተመሳሳይ ሞዴል ከሆኑ ብቻ ያረጋግጡ።",
  "Try a different name, email, or phone number.": "ሌላ ስም፣ ኢሜይል ወይም ስልክ ይሞክሩ።",
  "Try a different tag, model, owner, or phone number.": "ሌላ መለያ፣ ሞዴል፣ ባለቤት ወይም ስልክ ይሞክሩ።",
  "Unknown make": "ያልታወቀ ብራንድ",
  "Unknown user": "ያልታወቀ ተጠቃሚ",
  "Unnamed staff": "ስም የሌለው ሰራተኛ",
  "Unnamed user": "ስም የሌለው ተጠቃሚ",
  "unread ·": "ያልተነበበ ·",
  "unverified completed-sale calibration": "ያልተረጋገጠ የተጠናቀቀ ሽያጭ ማስተካከያ",
  "Update dealer": "አስመጪውን አዘምን",
  "Upload failed": "መጫን አልተሳካም",
  "Upload video": "ቪዲዮ ጫን",
  "Use photo": "ፎቶውን ተጠቀም",
  "Used car": "ያገለገለ መኪና",
  "User is suspended": "ተጠቃሚው ታግዷል",
  "User is suspended until": "ተጠቃሚው የታገደው እስከ",
  "User reports will appear here.": "የተጠቃሚ ሪፖርቶች እዚህ ይታያሉ።",
  "Uses the normal repost credit rule": "መደበኛውን የድጋሚ ልጥፍ ክሬዲት ህግ ይጠቀማል",
  "verified sale calibration": "የተረጋገጠ ሽያጭ ማስተካከያ",
  "Visible in Deals for 48 hours": "በቅናሾች ውስጥ ለ48 ሰዓት ይታያል",
  "Waiting for the BossCar Gari connector...": "የBossCar Gari አገናኝ እየተጠበቀ ነው...",
  "With driver": "ከሹፌር ጋር",
  "You are all caught up": "ሁሉንም አይተዋል",
  "Your message will appear here.": "መልእክትዎ እዚህ ይታያል።",
  Activate: "አግብር",
  Deactivate: "አቦዝን",
  All: "ሁሉም",
  Attention: "ትኩረት ያስፈልጋል",
  "Collecting...": "እየተሰበሰበ ነው...",
  Conversation: "ውይይት",
  "Deleting...": "እየተሰረዘ ነው...",
  Draft: "ረቂቅ",
  drafts: "ረቂቆች",
  Failed: "አልተሳካም",
  Hide: "ደብቅ",
  Show: "አሳይ",
  "Importing...": "እየገባ ነው...",
  Make: "ብራንድ",
  "Preparing...": "እየተዘጋጀ ነው...",
  "price(s)": "ዋጋ(ዎች)",
  Processing: "በሂደት ላይ",
  "Publishing...": "እየታተመ ነው...",
  "Reading...": "እየተነበበ ነው...",
  "Reposting...": "እንደገና እየተለጠፈ ነው...",
  Requested: "የተጠየቀ",
  "Saving...": "እየተቀመጠ ነው...",
  "Selected:": "የተመረጠ፦",
  "Sending...": "እየተላከ ነው...",
  Sent: "የተላከ",
  Trust: "ታማኝ አድርግ",
  Untrust: "ታማኝነትን አንሳ",
  Unknown: "ያልታወቀ",
  Unspecified: "ያልተገለጸ",
  Uploading: "እየተጫነ ነው",
  User: "ተጠቃሚ",
  approve: "አጽድቅ",
  reject: "ውድቅ አድርግ",
  merge: "አዋህድ",
  new: "አዲስ",
  used: "ያገለገለ",
  pending: "በመጠባበቅ ላይ",
  unread: "ያልተነበበ",
  total: "ጠቅላላ",
  dealers: "አስመጪዎች",
  inventory: "የመኪና ዝርዝር",
  leads: "የገዢ ጥያቄዎች",
  models: "ሞዴሎች",
  outcomes: "ውጤቶች",
  requests: "ጥያቄዎች",
  submissions: "ማስገቢያዎች",
  metadata: "ተጨማሪ መረጃ",
  marketing: "ማስተዋወቂያ",
  system: "ስርዓት",
  "km/charge": "ኪ.ሜ./ቻርጅ",
} satisfies Record<string, string>);

export const translateDashboardText = (value: string): string => {
  if (getDashboardLanguage() !== "am") return value;

  const normalized = value.trim().replace(/\s+/g, " ");
  if (!normalized) return value;
  const translated = amharicTranslations[normalized];
  const unitTranslated = translated
    ? translated
    : normalized
        .replace(/\bBirr\b/g, "ብር")
        .replace(/\bkm\b/gi, "ኪ.ሜ.");
  if (unitTranslated === normalized) return value;

  const leading = value.match(/^\s*/)?.[0] || "";
  const trailing = value.match(/\s*$/)?.[0] || "";
  return `${leading}${unitTranslated}${trailing}`;
};

export const localizeDashboardError = (value?: string): string => {
  const fallback = "ችግር ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።";
  if (getDashboardLanguage() !== "am") {
    return value || "Something went wrong. Please try again.";
  }
  if (!value) return fallback;
  const translated = translateDashboardText(value);
  return translated === value ? fallback : translated;
};

export const dashboardConfirm = (message: string): boolean => {
  if (getDashboardLanguage() !== "am") return window.confirm(message);

  const notificationMatch = message.match(/^Send this notification to (.+)\?$/);
  if (notificationMatch) {
    return window.confirm("ይህን ማሳወቂያ ለተመረጡት ተጠቃሚዎች ይላኩ?");
  }
  const deleteVideoMatch = message.match(/^Delete "(.+)"\?$/);
  if (deleteVideoMatch) {
    return window.confirm(`“${deleteVideoMatch[1]}” ይሰረዝ?`);
  }
  const userTypeMatch = message.match(
    /^Are you sure you want to change this customer into a (.+)\?$/
  );
  if (userTypeMatch) {
    return window.confirm("የዚህን ተጠቃሚ ዓይነት መቀየር ይፈልጋሉ?");
  }
  return window.confirm(translateDashboardText(message));
};
